
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22 4V2H2v20h2V4h16v18h2V4z","fill":"#2A333D"}}),_c('path',{attrs:{"fill":"#2A333D","d":"M4 8h16v2H4zM6 12h12v2H6zM6 16h6v2H6zM4 20h16v2H4z"}})])
          )
        }
      }
    